import {
    ConsoleFormattedStream,
    createLogger,
    stdSerializers
} from "browser-bunyan";
import * as React from "react";

import ItemStore from "./data/item";
import UserStore from "./data/user";

import Auth from "./login/auth";
import { IUserInfoProps } from "./login/userinfo";

const log = createLogger({
    name: 'console',
    serializers: stdSerializers,
    src: true,
    streams: [
        {
            level: "trace",
            stream: new ConsoleFormattedStream()
        }
    ]
});

enum LoginState {
    None,
    InProgress,
    Completed
}

interface IAppState {
    Error?: string
    UserInfo: IUserInfoProps
    LinkCompleted?: boolean
    Log: string[],
    LoginState: LoginState
    PerformLink?: boolean
    UserID: string | null
}

class Pricelist extends React.Component<{}, IAppState> {
    private auth = new Auth("pricelist");

    private store = {
        item: new ItemStore(this.auth.fetch),
        user: new UserStore(this.auth.fetch)
    };

    constructor(props: {}) {
        super(props);

        this.handleError = this.handleError.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
        this.handleLoginStateChange = this.handleLoginStateChange.bind(this);
        this.linkPricelist = this.linkPricelist.bind(this);

        this.state = {
            ...this.defaultState(),
            UserID: null
        }

        // If redirected from logon page, process the access token
        if (location.hash.indexOf("access_token") > 0) {
            log.debug("Access token in URL");
            this.auth.getToken(window.location).then(this.handleLogin);
        }
        else {
            // Otherwise, if the access token is still valid, fetch user data
            const urlUserId = location.href.substr(location.href.lastIndexOf('/') + 1);
            if (urlUserId === "pricelist" || urlUserId === "") {
                this.state = {
                    ...this.state,
                    Error: "No pricelist ID provided "
                };
            }
            else {
                if (this.auth.hasValidToken()) {
                    log.debug("Valid auth token found");
                    this.state.UserInfo.LoggedIn = true;
                    this.state = {
                        ...this.state,
                        LoginState: LoginState.Completed,
                        UserID: urlUserId
                    };
                }
                // Otherwise, we are not logged in
                else {
                    this.state = {
                        ...this.state,
                        LoginState: LoginState.None,
                        UserID: urlUserId
                    }
                }
            }
        }
    }

    public componentDidMount() {
        this.handleLoginStateChange();
    }

    public componentDidUpdate(_: {}, prevState: IAppState) {
        if (prevState.LoginState !== this.state.LoginState) {
            this.handleLoginStateChange();
        }
    }

    public render() {
        return this.state.Error ?
            <div className="error">
                {this.state.Error}
            </div>
            : <div>
                Åpner prisfil i Prisassistenten...
            </div>;
    }

    private handleError = (e: any) => {
        this.auth.clearToken();
        this.setState({ Error: e });
    }

    private handleLogin = () => {
        let userId = this.auth.token!.data.state;
        if (userId.charAt(0) === '!') {
            userId = userId.substr(1);
        }
        // Clear the address bar
        history.pushState("", document.title, window.location.pathname + window.location.search + "/" + userId);

        this.setState({
            LoginState: LoginState.Completed,
            UserID: userId,
            UserInfo: {
                ...this.state.UserInfo,
                LoggedIn: true
            }
        });
    }

    private redirectToLogin = () => {
        const uri = this.auth.getLogInUri({ state: (this.state.PerformLink ? "!" : "") + this.state.UserID! });
        log.debug("Redirecting to " + uri);
        location.href = uri;
    }

    private redirectToLogOut = () => {
        location.href = this.auth.getLogOutUri();
    }

    private defaultState() {
        return {
            Log: [],
            LoginState: LoginState.InProgress,
            UserInfo: {
                LogIn: this.redirectToLogin,
                LoggedIn: false,
                handleError: this.handleError,
                handleLogOut: this.redirectToLogOut
            }
        }
    };

    private handleLoginStateChange() {
        switch (this.state.LoginState) {
            case LoginState.Completed:
                log.debug("Login completed, linking pricelist");
                this.linkPricelist();
                break;
            case LoginState.None:
                log.debug("Not logged in, redirecting to logon page");
                this.redirectToLogin();
                break;
            case LoginState.InProgress:
                log.debug("Logon in progress, not taking any action");
                break;
        }
    }

    private linkPricelist() {
        log.debug("Link pricelist, user ID " + this.state.UserID!);
        this.store.item.linkPricelist(this.state.UserID!)
            .then(x => {
                if (x.status === 404) {
                    log.debug("User ID not found (" + this.state.UserID + ")");
                    this.setState({ Error: "Finner ikke LagPris-kunde med ID '" + this.state.UserID + "'" });
                }
                else if (x.status === 401) {
                    log.debug("Not authorized, redirecting to login page");
                    this.redirectToLogin();
                }
                else {
                    log.debug("Link succeeded");
                    x.json().then(id => {
                        log.debug("Pricelist id is " + id);
                        const urlRedirect = this.store.item.urlPricelistRedirect(id);
                        log.debug("Redirecting to " + urlRedirect);
                        window.location.href = urlRedirect;
                    })
                }
            });
    }

}

export default Pricelist;


// WEBPACK FOOTER //
// ./src/pricelist.tsx